import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Wand2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, emitPostsChanged, pollAiPending } from "@/lib/api";
import { useClient } from "@/context/ClientContext";

const day = (s) => new Date(s).toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" });

export default function AutofillButton({ start, label = "Aus Drive einplanen", onDone, testId = "autofill-button" }) {
  const { clientId } = useClient();
  const [busy, setBusy] = useState(false);
  const undo = async (batch) => {
    try { const r = await api.post(`/ai/autofill/${batch}/undo`); toast.success(`${r.data.deleted} Beiträge entfernt`); emitPostsChanged(); onDone?.(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const run = async () => {
    setBusy(true);
    try {
      const { data: d } = await api.post("/ai/autofill", { client_id: clientId, start });
      const skip = d.skipped.video + d.skipped.photo;
      if (d.created === 0) toast.info(skip ? "Für diese Dateien gibt es keinen passenden Rhythmus-Tag (Video-/Foto-Tage prüfen)." : "Keine neuen Dateien im Drive – alles ist schon eingeplant.");
      else toast.success(`${d.created} eingeplant (${d.videos} Video, ${d.photos} Foto): ${d.dates.map(day).join(", ")}`, {
        description: "Captions werden gerade geschrieben…", duration: 15000,
        action: { label: "Rückgängig", onClick: () => undo(d.batch_id) },
      });
      emitPostsChanged();
      onDone?.();
      if (d.created) pollAiPending(clientId);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Button onClick={run} disabled={busy} className="bg-purple-600 hover:bg-purple-500 text-white gap-2" data-testid={testId}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wand2 className="h-4 w-4" />}{label}
    </Button>
  );
}
